import { render, staticRenderFns } from "./type-full.vue?vue&type=template&id=3e551c61&"
import script from "./type-full.vue?vue&type=script&lang=js&"
export * from "./type-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports